<template>
  <div>
    <a-card class="filter-card">
      <a-form-model :form="filterForm" :label-col="{ span: 6 }" :model="filterForm" class="search-form">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-model-item label="服务名称">
              <a-input v-model="filterForm.name" placeholder="服务名称" class="form-model-item" @change="handleChange" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="服务类型">
              <a-select v-model="filterForm.service_type" allow-clear @change="onSearch">
                <a-select-option :value="1"> 后端 </a-select-option>
                <a-select-option :value="2"> 前端 </a-select-option>
                <a-select-option :value="3"> Apple </a-select-option>
                <a-select-option :value="4"> Android </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="存活状态">
              <a-select v-model="filterForm.status" allow-clear @change="onSearch">
                <a-select-option :value="0"> 正常 </a-select-option>
                <a-select-option :value="1"> 异常 </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="6" style="float: right; text-align: right">
            <a-button v-tc="{ name: '查询' }" type="primary" @click="onSearch">查询</a-button>
            <a-button v-tc="{ name: '重置' }" :style="{ margin: '0 8px' }" @click="onReset">重置</a-button>
          </a-col>
        </a-row>
      </a-form-model>
    </a-card>
    <a-card size="small">
      <a-tabs v-model="activeKey" @tabClick="onTabClick" @change="onSearch">
        <a-tab-pane v-for="env in envs" :key="env.key" :tab="env.value" />
      </a-tabs>
      <service-list ref="serviceListRef" />
    </a-card>
  </div>
</template>

<script>
import { debounce } from 'lodash';
import ServiceList from '@/pages/project/service/components/ServiceList';

export default {
  components: { ServiceList },
  data() {
    return {
      filterForm: {
        name: null,
        status: null,
        service_type: null
      },
      activeKey: 'qa',
      envs: [
        { key: 'dev', value: '开发环境' },
        { key: 'qa', value: 'QA环境' },
        { key: 'alpha', value: 'Alpha环境' },
        { key: 'prod', value: '生产环境' }
      ]
    };
  },
  mounted() {
    this.onSearch();
  },
  methods: {
    handleChange: debounce(function () {
      this.onSearch();
    }, 500),

    onTabClick(event) {
      this.utils.trackClick({ name: '切换环境', $value: event.key });
    },

    onSearch() {
      this.$nextTick(() => {
        this.$refs.serviceListRef.onFilter({ environment: this.activeKey, ...this.filterForm });
      });
    },

    onReset() {
      this.filterForm = {
        name: null,
        status: null,
        service_type: null
      };
      this.onSearch();
    }
  }
};
</script>

<style lang="less">
.search-form .ant-form-item {
  display: flex;
}

.search-form .ant-form-item-control-wrapper {
  flex: 1;
}
</style>
<style lang="less" scoped>
.filter-card {
  margin-bottom: 16px;
}
.ant-form-item {
  margin-bottom: 0;
}
</style>
